// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"bd2bef22","72":"893bc761","128":"74fcec23","463":"cb4cf1e1","509":"983de268","619":"fc866880","796":"fc866880","903":"893bc761","932":"9faaf8ee"}[chunkId] + ".chunk.css";
};